import "./TheProcess.module.css";
import MainNavigation from "@/reusable_sections/Header";
import YourPathToANewLook from "./sections/YourPathToANewLook";
import StepByStepExcellence from "./sections/StepByStepExcellence";
import CommonQuestions from "./sections/CommonQuestions";
import SiteFooter from "@/reusable_sections/Footer";
export default function TheProcessPage() {
  return <div>
      <MainNavigation />
      <YourPathToANewLook />
      <StepByStepExcellence />
      <CommonQuestions />
      <SiteFooter />
    </div>;
}